import { useContext, useEffect } from 'react'

import { LoaderOverlay } from 'components/Loader'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { selectedHomeSelector } from 'features/home/selectors'
import { fetchHomeThunk } from 'features/home/slice'
import { HomeStateContext } from 'features/home/homeStateContext'

import MainInfo from './MainInfo'
import SubInfo from './SubInfo'
import { HomeStatusLayout } from './styles'
import { fetchHomeAvailableSoftwareThunk } from '../HomeSoftware/slice'
import NetworkHomeWidget from 'features/networkAi/NetworkHomeWidget'

function HomeStatus() {
  const { isOnline } = useContext(HomeStateContext)
  const currentHome = useAppSelector(selectedHomeSelector.data)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (currentHome?.id) {
      dispatch(
        fetchHomeAvailableSoftwareThunk(currentHome.id, { location: true })
      )
      // refetching home info, it could have changed while another tab was active
      dispatch(fetchHomeThunk(currentHome.id))
    }
  }, [currentHome?.id, dispatch])

  if (!currentHome) return <LoaderOverlay />

  return (
    <HomeStatusLayout>
      <MainInfo currentHome={currentHome} isOnline={!!isOnline} />
      <NetworkHomeWidget />
      <SubInfo lastBackup={currentHome.lastBackup} />
    </HomeStatusLayout>
  )
}

export default HomeStatus
